import * as t from 'io-ts';
import {IntegerSchema} from 'favorlogic-utils';

export const DilutionSchema = t.refinement(IntegerSchema, n => n >= 0 && n <= 9, 'Dilution');

export type Dilution = number;
